import * as React from "react";
function SvgLeaf(props) {
  return (
    <svg
      viewBox="0 0 183 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.577 8.896C34.553 10.241 26.793 9.955 21.56.186-11.204 90.44-18.145 250.447 102.41 274.458c27.101 5.401 66.223-7.955 79.337-36.298 2.321-5.007-3.022-7.308-6.88-4.742C51.842 307.972-16.286 134.877 30.754 38.742c2.12-4.91 5.467-6.998 10.128-8.454 16.48-5.218 33.866-8.172 51.293-8.691l27.142-16.993c-25.25-1.55-50.533.506-75.74 4.292z"
        fill="#03912C"
      />
    </svg>
  );
}
export default SvgLeaf;
